export default {
    DeviceWideProfile: {
        Title: "Quét thiết bị diện rộng - Mục tiêu",
        Name: "Mục tiêu",
        Exclude: "Đường dẫn",
        LastScaned: "Lần quét gần nhất",
        NextScaned: "Lần quét tiếp theo",
        Status: "Trạng thái",
        Targets: "Địa chỉ mục tiêu",
        Report: "Thống kê an ninh",
        SearchEmptyText: "Tìm theo mục tiêu, địa chỉ mục tiêu",
        Ports: "Cổng",
        TargetsDescription: "192.168.10.1,192.168.10.0/24\n192.168.10.1-240\n192.168.10.100",
        ScanIpCount: "Số IP",
        ScanPortCount: "Số cổng",
        ScanIssuesCount: "Số vấn đề",
        CreatedBy: "Người tạo",
        LastStarted: 'Thời gian bắt đầu',
        LastEnded: 'Thời gian kết thúc',
        Schedule: "Lịch quét",
    },
    DeviceDeepProfile: {
        Title: "Quét thiết bị chuyên sâu - Mục tiêu",
        Name: "Mục tiêu",
        Exclude: "Đường dẫn",
        LastScaned: "Lần quét gần nhất",
        NextScaned: "Lần quét tiếp theo",
        Status: "Trạng thái hoạt động",
        Targets: "Địa chỉ mục tiêu",
        Report: "Thống kê an ninh",
        SearchEmptyText: "Tìm theo mục tiêu",
        Ports: "Cổng",
        Result: "Kết quả",
        TargetsDescription: "192.168.10.1,192.168.10.0/24\n192.168.10.1-240\n192.168.10.100",
        PortList: 'Danh sách cổng',
        ScanConfig: 'Chế độ quét',
        Scanner: 'Tập rule',
        Action: 'Thao tác',
        LastStarted: 'Thời gian bắt đầu',
        LastEnded: 'Thời gian kết thúc',
        schedule_type: 'Tần suất lặp lại',
        schedule_start_time: 'Thời điểm bắt đầu',
        schedule_repeat: 'Ngày thực hiện',
        schedule_summary: 'Tóm lược',
        ScanOptionOne: '- Quét cơ bản (nhanh): Khảo sát ban đầu nhanh chóng, phát hiện host alive, dịch vụ cơ bản và lỗ hổng phổ biến trên phạm vi lớn. Phù hợp cho reconnaissance, lập danh sách target tiềm năng hoặc kiểm tra định kỳ với thời gian hạn chế. Danh sách cổng All IANA assigned TCP. Chế độ quét Base. Sử dụng tập rule CVE Scanner. Mức độ chuyên sâu Level 2. Tốc độ gửi lệnh quét Nhanh',
        ScanOptionTwo: '- Quét nâng cao (chậm): Phân tích chuyên sâu, phát hiện tối đa lỗ hổng và thông tin chi tiết. Phù hợp cho audit bảo mật toàn diện, pentest chính thức hoặc kiểm tra target quan trọng cần độ chính xác cao. Danh sách cổng thực hiện All TCP and Nmap top 100 UDP . Chế độ quét Full and fast with TCP sync. Tập rule Scanner. Mức độ chuyên sâu Level 4. Tốc độ gửi lệnh quét chậm',
        ScanOptionThree: '- Quét tùy chỉnh: Linh hoạt theo thông tin đã biết về target (ví dụ: tập trung web application, server cụ thể, hoặc kết hợp OSINT). Phù hợp khi đã có kết quả quét cơ bản và muốn đào sâu theo ngữ cảnh riêng. Danh sách cổng thực hiện All  IANA assigned TCP and. Chế độ quét Base. Tập rule Tùy chỉnh theo gợi ý về OS base, Phiên bản webserver, .... Mức độ chuyên sâu Level 4. Tốc độ gửi lệnh quét trung bình',
    },
    DeepProfile: {
        TargetsDescription: "80.82.116.51\n24h.com.vn",
    },
    Device: {
        Title: "Quét thiết bị diện rộng - Thiết bị",
        SearchEmptyText: "Tìm theo thiết bị",
    },
    ScanEngine: {
        Title: "Danh sách Engine",
        SearchEmptyText: "Tìm theo tên Engine",
        Name: "Tên",
        Code: "Mã",
        DeployInfo: "Thông tin máy chủ",
        ScanConfig: "Cấu hình",
        Inactive: "Ngưng hoạt động",
        Type: 'Phân loại',
        Level: 'Mức độ quét',
        EngineCode: 'Mức độ chuyên sâu',
        Tags: "Nhãn",
        Created: "Ngày tạo"
    },
    User: {
        Title: "Danh sách người dùng",
        SearchEmptyText: "Tìm theo tên người dùng",
        UserName: "Tên đăng nhập",
        FullName: "Tên đầy đủ",
        Role: "Vai trò",
        Password: "Mật khẩu",
        Inactive: "Ngừng theo dõi",
        Created: 'Ngày tạo',
        Logined: 'Lần đăng nhập cuối'
    },
    Evidence: {
        Title: "Danh sách dẫn chứng",
        SearchEmptyText: "Tìm theo tên dẫn chứng",       
    },
    UserRole: {
        Title: "Danh sách vai trò",
        RoleCode: "Mã vai trò",
        RoleName: "Tên vai trò",
        Description: "Mô tả",
        IsAdmin: "Toàn quyền (Có quyền vào tất cả các danh mục)"
    },
    DeviceWideTaskResult: {
        Title: "Quét thiết bị diện rộng - Tác vụ",
        Target: "Mục tiêu",
        Ip: "IP",
        Port: "Cổng",
        Protocol: "Giao thức",
        Status: "Trạng thái",
        Device: "Thiết bị",
        Created: "Ngày quét",
        SearchEmptyText: "Tìm theo mục tiêu, ip",
        device_type: "Loại thiết bị",
        banner: "Phiên bản",
    },
    DeviceDeepTaskResult: {
        Title: "Quét thiết bị chuyên sâu - Tác vụ",
        SearchEmptyText: "Tìm theo mục tiêu hoặc ip"
    },
    DeviceWideProfileResult: {
        Title: "Kết quả quét diện rộng"
    },
    IpSearch: {
        Title: "Tra cứu theo IP",
        SearchEmptyText: "Nhập địa chỉ ip cần tra cứu",
        BtnSearch: "Tra cứu"
    },
    IpSearchPort: {
        SearchEmptyText: "Tra cứu theo cổng",
    },
    IpSearchIssues: {
        SearchEmptyText: "Tra cứu theo vấn đề",
    },
    EngineDictionary: {
        Title: "Danh mục thông tin engine"
    }
};  
